import { render } from "./priceFilter.vue?vue&type=template&id=23b14e11&scoped=true"
import script from "./priceFilter.vue?vue&type=script&lang=js"
export * from "./priceFilter.vue?vue&type=script&lang=js"

import "./priceFilter.vue?vue&type=style&index=0&id=23b14e11&lang=scss"
import "./priceFilter.vue?vue&type=style&index=1&id=23b14e11&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b14e11"]])

export default __exports__